import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const AdultIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "AdultGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M11.9997 6.34419C10.8018 6.34419 9.82757 5.36995 9.82757 4.17209C9.82757 2.97424 10.8018 2 11.9997 2C13.1975 2 14.1718 2.97424 14.1718 4.17209C14.1718 5.36995 13.1975 6.34419 11.9997 6.34419ZM11.9997 3.00872C11.3584 3.00872 10.8363 3.53081 10.8363 4.17209C10.8363 4.81338 11.3584 5.33547 11.9997 5.33547C12.6409 5.33547 13.163 4.81338 13.163 4.17209C13.163 3.53081 12.6409 3.00872 11.9997 3.00872Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.0498 22C12.6454 22 12.2765 21.8444 11.9997 21.5912C11.7229 21.8444 11.3539 22 10.9496 22C10.0926 22 9.39511 21.3026 9.39511 20.4455V15.2581C9.22519 15.3222 9.04147 15.3566 8.84938 15.3566C7.99236 15.3566 7.29492 14.6592 7.29492 13.8022V9.5437C7.29492 8.30841 8.30019 7.30364 9.53548 7.30364H14.4638C15.6991 7.30364 16.7044 8.30841 16.7044 9.5437V13.8022C16.7044 14.6592 16.0069 15.3566 15.1499 15.3566C14.9578 15.3566 14.7741 15.3222 14.6042 15.2581V20.4455C14.6042 21.3026 13.9068 22 13.0498 22ZM11.9997 19.9412C12.2784 19.9412 12.504 20.1668 12.504 20.4455C12.504 20.746 12.7488 20.9913 13.0498 20.9913C13.3507 20.9913 13.5955 20.746 13.5955 20.4455V13.8022C13.5955 13.5234 13.8211 13.2978 14.0999 13.2978C14.3786 13.2978 14.6042 13.5234 14.6042 13.8022C14.6042 14.1026 14.849 14.3479 15.15 14.3479C15.4509 14.3479 15.6957 14.1026 15.6957 13.8022V9.5437C15.6957 8.86498 15.1431 8.31236 14.4639 8.31236H9.53552C8.85631 8.31236 8.30368 8.86498 8.30368 9.5437V13.8022C8.30368 14.1026 8.54848 14.3479 8.84942 14.3479C9.15036 14.3479 9.39515 14.1026 9.39515 13.8022C9.39515 13.5234 9.62073 13.2978 9.89951 13.2978C10.1783 13.2978 10.4039 13.5234 10.4039 13.8022V20.4455C10.4039 20.746 10.6487 20.9913 10.9496 20.9913C11.2506 20.9913 11.4953 20.746 11.4953 20.4455C11.4953 20.1668 11.7209 19.9412 11.9997 19.9412Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.9997 20.9499C11.7209 20.9499 11.4953 20.7243 11.4953 20.4455L11.4953 13.9086C11.4953 13.6298 11.7209 13.4042 11.9997 13.4042C12.2784 13.4042 12.504 13.6298 12.504 13.9086V20.4455C12.504 20.7243 12.2784 20.9499 11.9997 20.9499Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.0998 14.3066C13.8211 14.3066 13.5955 14.081 13.5955 13.8022L13.5955 10.6332C13.5955 10.3544 13.8211 10.1288 14.0998 10.1288C14.3786 10.1288 14.6042 10.3544 14.6042 10.6332L14.6042 13.8022C14.6042 14.081 14.3786 14.3066 14.0998 14.3066Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.88421 14.3066C9.60543 14.3066 9.37985 14.081 9.37985 13.8022V10.6332C9.37985 10.3544 9.60543 10.1288 9.88421 10.1288C10.163 10.1288 10.3886 10.3544 10.3886 10.6332V13.8022C10.3886 14.081 10.163 14.3066 9.88421 14.3066Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default AdultIcon;
